"use strict";

const $ = jQuery;
const dataLayer = window.dataLayer || [];

module.exports = class {
	#$module;
    #$accordion;
    #$toggle;
    #$shareLinkContainer;
    #$shareLink;
    #$siteHeader;
    
	#data;

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;
        this.#$accordion = $module.find('.accordion');
        this.#$toggle = $module.find('.accordion-header > .accordion-button');
        this.#$shareLinkContainer = $module.find('.share-link-container');
        this.#$shareLink = this.#$shareLinkContainer.find('a.share-link');
        this.#$siteHeader = $('body > header');

        this.bind();

        const anchorId = `#${this.getAnchorId()}`;

        requestAnimationFrame(() => {
            if (location.hash === anchorId) {
                if (!this.isExpanded()) {
                    this.#$toggle.trigger('click');
                }
                this.scrollTo();
            }
        });
	}

    bind() {
        $(window).on('hashchange', (event) => { return this.onHashChange(event); });
        this.$shareLink.on('click', (event) => { return this.onShareLinkClick(event); });

        this.$accordion.on('show.bs.collapse', (event) => { return this.onAccordionOpen(event); });
        this.$accordion.on('hide.bs.collapse', (event) => { return this.onAccordionClose(event); });
        
        $('html').on(`bb-lumeris:lum-advanced-accordion:${this.data.parent}:close`, (event, data) => { return this.onTriggerAccordionClose(event, data); });
    }

    get $module() {
        return this.#$module;
    }

    get $accordion() {
        return this.#$accordion;
    }

    get $toggle() {
        return this.#$toggle;
    }

    get $shareLinkContainer() {
        return this.#$shareLinkContainer;
    }

    get $shareLink() {
        return this.#$shareLink;
    }

    get $siteHeader() {
        return this.#$siteHeader;
    }

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.settings.id;
    }

    get moduleId() {
        return this.data.node;
    }

    getAnchorId() {
        return (this.data.settings.anchor_id) ? this.data.settings.anchor_id : `${this.data.node}-accordion`;
    }

    isExpanded() {
        return (this.$toggle.hasClass('collapsed') && this.$toggle.attr('aria-expanded') === 'false') ? false : true;
    }

    scrollTo() {
        const scrollTopMargin = Number(this.$module.css('scroll-margin-top').replace('px', '')) || Number(this.$accordion.css('scroll-margin-top').replace('px',''));
        $(window).scrollTop(this.$module.offset().top - this.$siteHeader.height() - scrollTopMargin);
    }
    
    onHashChange(event) {
        if (event.type !== 'hashchange') {
            return null;
        } 

        if (location.hash === `#${this.getAnchorId()}` && !this.isExpanded()) {
            this.$toggle.trigger('click');
        }
    }

    onTriggerAccordionClose(event, data) {
        if (event.type !== `bb-lumeris:lum-advanced-accordion:${this.data.parent}:close`) {
            return null;
        }

        if (data.moduleId === this.moduleId) {
            return null;
        }
    }

    onAccordionOpen(event) {
        if (event.namespace !== 'bs.collapse' || event.type !== 'show') {
            return null;
        }

        if (this.data.settings.event_on_open_active ?? null === 'yes') {
            dataLayer.push({
                event: 'accordionOpen',
                id: this.data.settings.anchor_id,
                label: this.data.settings.label,
                pageUrl: location.href
            });
        }
    }

    onAccordionClose(event) {
        if (event.namespace !== 'bs.collapse' || event.type !== 'hide') {
            return null;
        }

        if (this.data.settings.event_on_close_active ?? null === 'yes') {
            dataLayer.push({
                event: 'accordionClose',
                id: this.data.settings.anchor_id,
                label: this.data.settings.label,
                pageUrl: location.href
            });
        }
    }

    onShareLinkClick(event) {
        event.preventDefault();

        if (this.$shareLinkContainer.hasClass('copied')) {
            return null;
        }

        this.$shareLinkContainer.addClass('copied');

        if (navigator && navigator.clipboard) {
            const url = location.href.replace(location.hash, '').replace(location.search, '');
            const copyText = `${url}#${this.$accordion.attr('id')}`;
            navigator.clipboard.writeText(copyText);

            if (this.data.settings.event_on_copy_share_link_active ?? null === 'yes') {
                dataLayer.push({
                    event: "accordionLinkCopy",
                    id: this.data.settings.anchor_id,
                    label: this.data.settings.label,
                    pageUrl: location.href,
                    copyText: copyText
                });
            }
        }

        setTimeout(() => {
            this.$shareLinkContainer.removeClass('copied');
        }, 5000);
    }
}